module.exports = __webpack_public_path__ + "static/media/image10.28b7d00b.png";